import { render } from "./MovTransporte.vue?vue&type=template&id=0853b4c0&scoped=true"
import script from "./MovTransporte.vue?vue&type=script&lang=js"
export * from "./MovTransporte.vue?vue&type=script&lang=js"

import "./MovTransporte.vue?vue&type=style&index=0&id=0853b4c0&scoped=true&lang=scss"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0853b4c0"]])

export default __exports__